/**
 * Generated by orval 🍺
 * Do not edit manually.
 * OnEarly Core API
 * OnEarly Core HTTP API
 * OpenAPI spec version: 0.0.1
 */
import * as zod from 'zod';

export const mutateContentBodyAddFilesItemClientIdMax = 36;

export const mutateContentBodyAddFilesItemClientIdRegExp = new RegExp('^[a-z0-9._:-]+$');
export const mutateContentBodyAddFilesMax = 200;

export const mutateContentBodyAddNodesItemClientIdMax = 36;

export const mutateContentBodyAddNodesItemClientIdRegExp = new RegExp('^[a-z0-9._:-]+$');
export const mutateContentBodyAddNodesItemContentTypeClientIdMax = 36;

export const mutateContentBodyAddNodesItemContentTypeClientIdRegExp = new RegExp('^[a-z0-9._:-]+$');

export const mutateContentBodyAddNodesItemTypeDefinitionReferenceViewPredicatesItemPathTypeUuidsMax = 8;

export const mutateContentBodyAddNodesItemTypeDefinitionReferenceViewPredicatesMax = 10;

export const mutateContentBodyAddNodesItemTypeDefinitionReferenceViewSearchTermsItemMax = 200;

export const mutateContentBodyAddNodesItemTypeDefinitionReferenceViewSearchTermsMax = 10;

export const mutateContentBodyAddNodesItemTypeNameMax = 200;

export const mutateContentBodyAddNodesMax = 1000;

export const mutateContentBodyEditNodesItemExpectedOutgoingRevisionMax = 128;

export const mutateContentBodyEditNodesItemTypeDefinitionReferenceViewPredicatesItemPathTypeUuidsMax = 8;

export const mutateContentBodyEditNodesItemTypeDefinitionReferenceViewPredicatesMax = 10;

export const mutateContentBodyEditNodesItemTypeDefinitionReferenceViewSearchTermsItemMax = 200;

export const mutateContentBodyEditNodesItemTypeDefinitionReferenceViewSearchTermsMax = 10;

export const mutateContentBodyEditNodesItemTypeNameMax = 200;

export const mutateContentBodyEditNodesMax = 1000;

export const mutateContentBodyRemoveEdgesItemEdgeKeyMax = 200;

export const mutateContentBodyRemoveEdgesItemExpectedOutgoingRevisionMax = 128;

export const mutateContentBodyRemoveEdgesMax = 1000;

export const mutateContentBodyRootsItemClientIdMax = 36;

export const mutateContentBodyRootsItemClientIdRegExp = new RegExp('^[a-z0-9._:-]+$');
export const mutateContentBodyRootsItemNameMax = 100;

export const mutateContentBodyRootsMax = 50;

export const mutateContentBodySetEdgesItemEdgeDescriptionMax = 2000;

export const mutateContentBodySetEdgesItemEdgeKeyMax = 200;

export const mutateContentBodySetEdgesItemExpectedOutgoingRevisionMax = 128;

export const mutateContentBodySetEdgesItemFromClientIdMax = 36;

export const mutateContentBodySetEdgesItemFromClientIdRegExp = new RegExp('^[a-z0-9._:-]+$');
export const mutateContentBodySetEdgesItemMaxCountMin = 0;

export const mutateContentBodySetEdgesItemMinCountMin = 0;

export const mutateContentBodySetEdgesItemToClientIdMax = 36;

export const mutateContentBodySetEdgesItemToClientIdRegExp = new RegExp('^[a-z0-9._:-]+$');
export const mutateContentBodySetEdgesMax = 2000;

export const MutateContentBody = zod.object({
  addFiles: zod
    .array(
      zod.object({
        clientId: zod
          .string()
          .min(1)
          .max(mutateContentBodyAddFilesItemClientIdMax)
          .regex(mutateContentBodyAddFilesItemClientIdRegExp)
          .describe(
            'Caller-supplied reference for a node added in THIS request, unique within it. Wires edges to not-yet-persisted nodes and keys the response’s clientIdMap. Lowercase letters, numbers, and ._:- only.',
          ),
        fileUuid: zod.uuid().describe('UUID v4 identifier'),
        occurredAt: zod.iso.datetime({ offset: true }).optional(),
        subjectUuid: zod.uuid().nullish().describe('UUID v4 identifier'),
      }),
    )
    .max(mutateContentBodyAddFilesMax)
    .optional(),
  addNodes: zod
    .array(
      zod.object({
        clientId: zod
          .string()
          .min(1)
          .max(mutateContentBodyAddNodesItemClientIdMax)
          .regex(mutateContentBodyAddNodesItemClientIdRegExp)
          .describe(
            'Caller-supplied reference for a node added in THIS request, unique within it. Wires edges to not-yet-persisted nodes and keys the response’s clientIdMap. Lowercase letters, numbers, and ._:- only.',
          ),
        contentTypeClientId: zod
          .string()
          .min(1)
          .max(mutateContentBodyAddNodesItemContentTypeClientIdMax)
          .regex(mutateContentBodyAddNodesItemContentTypeClientIdRegExp)
          .optional()
          .describe(
            'An INSTANCE’s TYPE added in THIS request. XOR with `contentTypeUuid`. Not accepted on a TYPE node.',
          ),
        contentTypeUuid: zod
          .uuid()
          .optional()
          .describe(
            'For an INSTANCE, the TYPE it instantiates (XOR with `contentTypeClientId`). For a TYPE, an optional grouping parent — which must already exist.',
          ),
        occurredAt: zod.iso.datetime({ offset: true }).optional(),
        subjectUuid: zod.uuid().nullish().describe('UUID v4 identifier'),
        typeDefinition: zod
          .object({
            conformance: zod
              .enum(['open', 'lax', 'strict'])
              .optional()
              .describe(
                'open enforces slots and allows extra bodies; strict additionally rejects extra bodies; lax admits slot violations and reports them in audit. Omission preserves the stored declaration; null cannot clear it.',
              ),
            description: zod.string().nullish(),
            enums: zod
              .array(
                zod.object({
                  label: zod.string(),
                  value: zod.string(),
                }),
              )
              .nullish()
              .describe(
                'Ordered ENUM choices as { value, label } pairs. Both are preserved; this contract does not collapse a label into its value.',
              ),
            file: zod
              .object({
                allowedFormats: zod
                  .array(
                    zod.enum([
                      'pdf',
                      'doc',
                      'docx',
                      'xls',
                      'xlsx',
                      'csv',
                      'txt',
                      'jpeg',
                      'png',
                      'webp',
                      'gif',
                      'heic',
                      'md',
                      'html',
                      'mp3',
                      'm4a',
                      'wav',
                      'mp4',
                      'mov',
                      'webm',
                    ]),
                  )
                  .min(1)
                  .optional(),
              })
              .nullish(),
            metadata: zod
              .record(zod.string(), zod.unknown())
              .nullish()
              .describe(
                'Arbitrary authored metadata. Its keys are content, not command fields, and are stored and returned unaltered.',
              ),
            reference: zod
              .object({
                carbonCopy: zod.boolean().optional(),
                creation: zod.enum(['forbidden', 'optional', 'required']).optional(),
                edgeType: zod.enum(['INCLUDES', 'RELATES_TO']).optional(),
                typeLineageUuid: zod.uuid(),
                typeUuid: zod.uuid(),
                view: zod
                  .object({
                    predicates: zod
                      .array(
                        zod.object({
                          op: zod.enum(['exists', 'eq', 'contains', 'gte', 'lte']),
                          pathTypeUuids: zod
                            .array(zod.uuid())
                            .min(1)
                            .max(
                              mutateContentBodyAddNodesItemTypeDefinitionReferenceViewPredicatesItemPathTypeUuidsMax,
                            ),
                          value: zod.string().optional(),
                          valueType: zod
                            .enum(['STRING', 'NUMERIC', 'BOOLEAN', 'DATE', 'DATETIME'])
                            .optional(),
                        }),
                      )
                      .max(mutateContentBodyAddNodesItemTypeDefinitionReferenceViewPredicatesMax)
                      .optional(),
                    searchTerms: zod
                      .array(
                        zod
                          .string()
                          .min(1)
                          .max(
                            mutateContentBodyAddNodesItemTypeDefinitionReferenceViewSearchTermsItemMax,
                          ),
                      )
                      .max(mutateContentBodyAddNodesItemTypeDefinitionReferenceViewSearchTermsMax)
                      .optional(),
                  })
                  .nullish(),
              })
              .nullish(),
            signature: zod.looseObject({}).nullish(),
          })
          .optional(),
        typeName: zod
          .string()
          .min(1)
          .max(mutateContentBodyAddNodesItemTypeNameMax)
          .optional()
          .describe('Required for variant TYPE; rejected for INSTANCE.'),
        value: zod
          .object({
            booleanValue: zod.boolean().nullish(),
            dateValue: zod.string().nullish(),
            datetimeValue: zod.string().nullish(),
            jsonValue: zod.unknown().optional(),
            numericValue: zod.number().nullish(),
            stringValue: zod.string().nullish(),
          })
          .optional(),
        valueType: zod
          .enum(['STRING', 'NUMERIC', 'BOOLEAN', 'DATE', 'DATETIME', 'ENUM', 'JSON'])
          .optional(),
        variant: zod
          .enum(['TYPE', 'INSTANCE'])
          .describe(
            'Explicit, never inferred. A TYPE authors schema; an INSTANCE holds authored data.',
          ),
      }),
    )
    .max(mutateContentBodyAddNodesMax)
    .optional(),
  editNodes: zod
    .array(
      zod.object({
        contentUuid: zod
          .uuid()
          .describe(
            'The exact version being edited, as returned by GET. A stale version is a 409, not a silent replacement.',
          ),
        expectedOutgoingRevision: zod
          .string()
          .min(1)
          .max(mutateContentBodyEditNodesItemExpectedOutgoingRevisionMax)
          .optional()
          .describe(
            'Opaque revision of a source node’s outgoing edges and TYPE policy state, as returned by GET \/content\/{lineageUuid}. Supplied here it is a precondition: the write is refused with 409 if the source has changed since. A node UUID alone is insufficient — an edge-only change does not version its source.',
          ),
        occurredAt: zod.iso.datetime({ offset: true }).optional(),
        subjectUuid: zod.uuid().optional().describe('UUID v4 identifier'),
        typeDefinition: zod
          .object({
            conformance: zod
              .enum(['open', 'lax', 'strict'])
              .optional()
              .describe(
                'open enforces slots and allows extra bodies; strict additionally rejects extra bodies; lax admits slot violations and reports them in audit. Omission preserves the stored declaration; null cannot clear it.',
              ),
            description: zod.string().nullish(),
            enums: zod
              .array(
                zod.object({
                  label: zod.string(),
                  value: zod.string(),
                }),
              )
              .nullish()
              .describe(
                'Ordered ENUM choices as { value, label } pairs. Both are preserved; this contract does not collapse a label into its value.',
              ),
            file: zod
              .object({
                allowedFormats: zod
                  .array(
                    zod.enum([
                      'pdf',
                      'doc',
                      'docx',
                      'xls',
                      'xlsx',
                      'csv',
                      'txt',
                      'jpeg',
                      'png',
                      'webp',
                      'gif',
                      'heic',
                      'md',
                      'html',
                      'mp3',
                      'm4a',
                      'wav',
                      'mp4',
                      'mov',
                      'webm',
                    ]),
                  )
                  .min(1)
                  .optional(),
              })
              .nullish(),
            metadata: zod
              .record(zod.string(), zod.unknown())
              .nullish()
              .describe(
                'Arbitrary authored metadata. Its keys are content, not command fields, and are stored and returned unaltered.',
              ),
            reference: zod
              .object({
                carbonCopy: zod.boolean().optional(),
                creation: zod.enum(['forbidden', 'optional', 'required']).optional(),
                edgeType: zod.enum(['INCLUDES', 'RELATES_TO']).optional(),
                typeLineageUuid: zod.uuid(),
                typeUuid: zod.uuid(),
                view: zod
                  .object({
                    predicates: zod
                      .array(
                        zod.object({
                          op: zod.enum(['exists', 'eq', 'contains', 'gte', 'lte']),
                          pathTypeUuids: zod
                            .array(zod.uuid())
                            .min(1)
                            .max(
                              mutateContentBodyEditNodesItemTypeDefinitionReferenceViewPredicatesItemPathTypeUuidsMax,
                            ),
                          value: zod.string().optional(),
                          valueType: zod
                            .enum(['STRING', 'NUMERIC', 'BOOLEAN', 'DATE', 'DATETIME'])
                            .optional(),
                        }),
                      )
                      .max(mutateContentBodyEditNodesItemTypeDefinitionReferenceViewPredicatesMax)
                      .optional(),
                    searchTerms: zod
                      .array(
                        zod
                          .string()
                          .min(1)
                          .max(
                            mutateContentBodyEditNodesItemTypeDefinitionReferenceViewSearchTermsItemMax,
                          ),
                      )
                      .max(mutateContentBodyEditNodesItemTypeDefinitionReferenceViewSearchTermsMax)
                      .optional(),
                  })
                  .nullish(),
              })
              .nullish(),
            signature: zod.looseObject({}).nullish(),
          })
          .optional(),
        typeName: zod
          .string()
          .min(1)
          .max(mutateContentBodyEditNodesItemTypeNameMax)
          .optional()
          .describe('Rename a TYPE. Rejected on an INSTANCE.'),
        value: zod
          .object({
            booleanValue: zod.boolean().nullish(),
            dateValue: zod.string().nullish(),
            datetimeValue: zod.string().nullish(),
            jsonValue: zod.unknown().optional(),
            numericValue: zod.number().nullish(),
            stringValue: zod.string().nullish(),
          })
          .optional(),
        variant: zod
          .enum(['TYPE', 'INSTANCE'])
          .describe(
            'Asserted stored variant. Verified against storage; a mismatch is a 409. This is not a conversion request.',
          ),
      }),
    )
    .max(mutateContentBodyEditNodesMax)
    .optional(),
  idempotencyKey: zod
    .uuid()
    .describe(
      'Caller-generated, required. Same key + same command returns the stored receipt instead of writing twice; same key + a DIFFERENT command is a 409. Reuse it verbatim when retrying.',
    ),
  performAs: zod
    .object({
      actorUuid: zod.uuid().optional().describe('UUID v4 identifier'),
      principalType: zod.enum(['USER', 'GROUP', 'GROUP_MEMBER']),
    })
    .optional(),
  removeEdges: zod
    .array(
      zod.object({
        edgeKey: zod
          .string()
          .max(mutateContentBodyRemoveEdgesItemEdgeKeyMax)
          .nullable()
          .describe(
            'The slot key you expect this edge to carry, or null for an edge you expect to be unkeyed. Checked, not ignored.',
          ),
        edgeType: zod.enum(['CONTAINS', 'RELATES_TO', 'INCLUDES']),
        expectedOutgoingRevision: zod
          .string()
          .min(1)
          .max(mutateContentBodyRemoveEdgesItemExpectedOutgoingRevisionMax)
          .optional()
          .describe(
            'Opaque revision of a source node’s outgoing edges and TYPE policy state, as returned by GET \/content\/{lineageUuid}. Supplied here it is a precondition: the write is refused with 409 if the source has changed since. A node UUID alone is insufficient — an edge-only change does not version its source.',
          ),
        fromContentUuid: zod.uuid().describe('UUID v4 identifier'),
        toContentUuid: zod.uuid().describe('UUID v4 identifier'),
      }),
    )
    .max(mutateContentBodyRemoveEdgesMax)
    .optional(),
  roots: zod
    .array(
      zod.object({
        clientId: zod
          .string()
          .min(1)
          .max(mutateContentBodyRootsItemClientIdMax)
          .regex(mutateContentBodyRootsItemClientIdRegExp)
          .optional()
          .describe(
            'Caller-supplied reference for a node added in THIS request, unique within it. Wires edges to not-yet-persisted nodes and keys the response’s clientIdMap. Lowercase letters, numbers, and ._:- only.',
          ),
        contentUuid: zod.uuid().optional().describe('UUID v4 identifier'),
        name: zod
          .string()
          .min(1)
          .max(mutateContentBodyRootsItemNameMax)
          .describe(
            'Caller’s label for this root, echoed in the response so a batch with several roots can be reattached without positional guessing.',
          ),
      }),
    )
    .max(mutateContentBodyRootsMax)
    .optional(),
  setEdges: zod
    .array(
      zod.object({
        carbonCopy: zod.boolean().optional(),
        certainty: zod.enum(['ASSERTED', 'INFERRED', 'SUGGESTED']).optional(),
        edgeDescription: zod
          .string()
          .max(mutateContentBodySetEdgesItemEdgeDescriptionMax)
          .nullish()
          .describe(
            'Authored edge text. An explicit empty string is a value and is stored; descriptions never define edge identity.',
          ),
        edgeKey: zod
          .string()
          .max(mutateContentBodySetEdgesItemEdgeKeyMax)
          .nullish()
          .describe(
            'Schema slot key on a TYPE→TYPE declaration: lower snake_case, unique per source TYPE across CONTAINS and INCLUDES. Preserved across a target rename or reorder — never re-derived from a changed type name. Omission preserves the stored key; null clears it. INSTANCE CONTAINS role keys use lower snake_case. Omission preserves an existing role or creates an unkeyed edge.',
          ),
        edgeType: zod.enum(['CONTAINS', 'RELATES_TO', 'INCLUDES']),
        expectedOutgoingRevision: zod
          .string()
          .min(1)
          .max(mutateContentBodySetEdgesItemExpectedOutgoingRevisionMax)
          .optional()
          .describe(
            'Opaque revision of a source node’s outgoing edges and TYPE policy state, as returned by GET \/content\/{lineageUuid}. Supplied here it is a precondition: the write is refused with 409 if the source has changed since. A node UUID alone is insufficient — an edge-only change does not version its source.',
          ),
        fromClientId: zod
          .string()
          .min(1)
          .max(mutateContentBodySetEdgesItemFromClientIdMax)
          .regex(mutateContentBodySetEdgesItemFromClientIdRegExp)
          .optional()
          .describe(
            'Caller-supplied reference for a node added in THIS request, unique within it. Wires edges to not-yet-persisted nodes and keys the response’s clientIdMap. Lowercase letters, numbers, and ._:- only.',
          ),
        fromContentUuid: zod.uuid().optional().describe('UUID v4 identifier'),
        maxCount: zod.int().min(mutateContentBodySetEdgesItemMaxCountMin).nullish(),
        minCount: zod.int().min(mutateContentBodySetEdgesItemMinCountMin).nullish(),
        position: zod.int().nullish(),
        toClientId: zod
          .string()
          .min(1)
          .max(mutateContentBodySetEdgesItemToClientIdMax)
          .regex(mutateContentBodySetEdgesItemToClientIdRegExp)
          .optional()
          .describe(
            'Caller-supplied reference for a node added in THIS request, unique within it. Wires edges to not-yet-persisted nodes and keys the response’s clientIdMap. Lowercase letters, numbers, and ._:- only.',
          ),
        toContentUuid: zod.uuid().optional().describe('UUID v4 identifier'),
      }),
    )
    .max(mutateContentBodySetEdgesMax)
    .optional(),
});

export type MutateContentBody = zod.input<typeof MutateContentBody>;
export type MutateContentBodyOutput = zod.output<typeof MutateContentBody>;
